import { ProductTarget } from '@upright/common/model/versions/types';

export enum Maturity {
  PRE_RELEASE = 'pre-release',
  LATEST_PUBLIC = 'latest',
  STABLE = 'stable',
  DELETED = 'deleted',
  /**
   * @deprecated
   */
  NIGHTLY = 'nightly',
  /**
   * @deprecated
   */
  MASTER = 'master',
}

export interface Release {
  number: string;
  maturity: Maturity;
  defaultVersion: string;
}

export interface ExtendedRelease extends Release {
  description: string;
  publishedOn?: string;
  publishedUntil?: string;
  productTarget: ProductTarget;
}

export interface ReleaseAndVersion {
  number: string;
  resolvedProductTarget: string;
}
